import { MapPin, Navigation } from "lucide-react";
import { LOCATIONS } from "@/data/content";

export default function LocationsSection() {
  return (
    <section id="locations" className="scroll-mt-24 px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24" data-testid="locations-section">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 max-w-2xl sm:mb-14" data-reveal>
          <p className="kicker mb-4">Our Footprint</p>
          <h2 className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Pan-India presence, local support
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-400 sm:text-base">
            BIGBOSS DIGITECH operates from Guwahati, Assam (head office) and Andheri West, Mumbai,
            with pan-India project support — so multi-location projects get one team, one standard
            and one point of accountability.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {LOCATIONS.map((loc, i) => (
            <article
              key={loc.id}
              data-testid={`location-card-${loc.id}`}
              data-reveal
              data-delay={i * 0.1}
              className="group overflow-hidden rounded-2xl border border-slate-700/70 bg-slate-900/50 transition-all duration-500 hover:-translate-y-1.5 hover:border-brand/60"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={loc.img}
                  alt={loc.alt}
                  loading="lazy"
                  width={loc.id === "guwahati" ? 800 : 1000}
                  height={loc.id === "guwahati" ? 600 : 667}
                  className="h-full w-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19] via-[#0B0F19]/30 to-transparent" />
                <div className="absolute bottom-4 left-5 right-5">
                  <p className="font-tech text-[10px] uppercase tracking-[0.25em] text-brand">{loc.region}</p>
                  <h3 className="mt-1 font-heading text-2xl font-bold text-white">{loc.city}</h3>
                </div>
              </div>
              <div className="flex items-start justify-between gap-4 p-5">
                <p className="flex items-start gap-2 text-xs leading-relaxed text-slate-300 sm:text-sm">
                  <MapPin size={15} className="mt-0.5 shrink-0 text-brand" />
                  {loc.address}
                </p>
                <a
                  data-testid={`location-directions-${loc.id}`}
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`Bigboss Digitech ${loc.address}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Get directions to our ${loc.city} office`}
                  className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-600 text-slate-300 transition-all duration-300 hover:border-brand hover:bg-brand hover:text-white"
                >
                  <Navigation size={15} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
